import React, { useState } from "react";
import AnimateFromBottom from "../../LandingPage/component/AnimateFromBottom";
import language from "../../../helpers/language";

const gridPattern = {
  backgroundImage:
    "linear-gradient(to right, rgba(180,200,230,0.15) 1px, transparent 1px), linear-gradient(to bottom, rgba(180,200,230,0.15) 1px, transparent 1px)",
  backgroundSize: "60px 60px",
};

const HowItWorks = () => {
  const [lang] = useState(language.getLang());

  const steps = [
    { number: "01", title: lang?.howItWorks_step1_title, desc: lang?.howItWorks_step1_desc },
    { number: "02", title: lang?.howItWorks_step2_title, desc: lang?.howItWorks_step2_desc },
    { number: "03", title: lang?.howItWorks_step3_title, desc: lang?.howItWorks_step3_desc },
  ];

  return (
    <section className="md:px-14 px-4 md:py-14 py-10 bg-[#f0f8fd]">
      <div
        className="relative max-w-6xl mx-auto md:px-8 px-4 md:pt-10 md:pb-14 py-9 overflow-hidden rounded-xl"
        style={{ background: "linear-gradient(180deg,#eef7fc 0%,#f7fcff 100%)" }}
      >
        {/* Subtle grid pattern */}
        <div className="absolute inset-0 pointer-events-none" style={gridPattern} />

      <div className="relative">
        {/* Pill */}
        <AnimateFromBottom delay={0.1}>
          <div className="flex justify-center mb-6">
            <span className="inline-block bg-blue-400 text-white text-xs font-semibold px-10 py-2 rounded">
              {lang?.howItWorks_pill}
            </span>
          </div>
        </AnimateFromBottom>

        {/* Heading */}
        <AnimateFromBottom delay={0.2}>
          <h2 className="text-center text-gray-900 font-extrabold text-3xl md:text-4xl mb-16">
            {lang?.howItWorks_title}
          </h2>
        </AnimateFromBottom>

        {/* Step cards */}
        <div className="grid md:grid-cols-3 gap-5 mt-10">
          {steps.map(({ number, title, desc }, i) => (
            <AnimateFromBottom delay={0.3 + i * 0.1} key={number}>
              <div className="bg-white border border-gray-200 rounded-md shadow-sm md:px-8 px-6 py-7 text-center h-full min-h-[165px]">
                <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-5">
                  <span className="text-teal-600 font-bold text-base">{number}</span>
                </div>
                <h4 className="text-gray-900 font-bold text-sm md:text-base mb-3 leading-tight">
                  {title}
                </h4>
                <p className="text-gray-500 text-xs leading-snug">{desc}</p>
              </div>
            </AnimateFromBottom>
          ))}
        </div>
      </div>
      </div>
    </section>
  );
};

export default HowItWorks;
